import React, { useEffect, useState } from "react";
import icon from "../assets/apple-touch-icon.png";
import { NavLink } from "react-router-dom";
import ResetPassword from "../components/reset_password/ResetPassword";

const ResetPasswordPage = () => {
  return (
    <section className="max-w-[1650px] mx-auto py-6 px-10 bg-custom-bg bg-cover bg-center min-h-screen">
      <header>
        <div className="flex justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-1">
            <img src={icon} alt="icon" className="h-10 w-10 text-orange-500" />
            <h3 className="text-xl font-bold">Vaspay</h3>
          </div>
          <NavLink
            to="register"
            className="px-4 py-2 rounded-md bg-red-500 text-white font-medium hover:bg-red-600 transition-colors duration-200 capitalize"
          >
            Register
          </NavLink>
        </div>
      </header>
      <main>
        <ResetPassword />
      </main>
    </section>
  );
};

export default ResetPasswordPage;
